import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import i18n from '@/plugins/vue-i18n';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
    options: {
      customProperties: true,
    },
  },
  lang: {
    current: i18n.locale,
  },
  icons: {
    iconfont: 'fa',
  },
});
